export * from './lib/pois-feature-poi-management.module';
export { PoiDetailComponent } from './lib/poi-detail/poi-detail.component';
export { PoisComponent } from './lib/pois.component';



